export const USER_PERMISSIONS = {
    PHONE_MANAGEMENT_VIEW: "settings.phone_management.view",
    PHONE_MANAGEMENT_ADD: "settings.phone_management.add",
    PHONE_MANAGEMENT_EDIT: "settings.phone_management.edit",
    PHONE_MANAGEMENT_DELETE: "settings.phone_management.delete",
    BRAND_REGISTRATION_VIEW: "settings.texting/tcr.brand_registration.view",
    BRAND_REGISTRATION_ADD: "settings.texting/tcr.brand_registration.add",
    BRAND_REGISTRATION_EDIT: "settings.texting/tcr.brand_registration.edit",
    CAMPAIGN_REGISTRATION_VIEW: "settings.texting/tcr.campaign_registration.view",
    CAMPAIGN_REGISTRATION_ADD: "settings.texting/tcr.campaign_registration.add",
    CAMPAIGN_REGISTRATION_EDIT: "settings.texting/tcr.campaign_registration.edit",
    CAMPAIGN_REGISTRATION_DELETE: "settings.texting/tcr.campaign_registration.delete",
    USAGE_STATS_VIEW: "settings.account_management.usage_stats.view",
    TEXTING_PREFERENCES_VIEW: "settings.texting/tcr.texting_preferences.view",
    TEXTING_PREFERENCES_EDIT: "settings.texting/tcr.texting_preferences.edit",
    TEXTING_HISTORY_VIEW: "reports/logs.text_history.view",
    TEXTING_HISTORY_REPORT_VIEW: "settings.reports_and_logs.text_history_report.view",
    ARCHIVE_VIEW: "settings.reports_and_logs.archive.view",
    CALL_HISTORY_REPORT_VIEW: "settings.reports_and_logs.call_history_report.view",
    CALL_HISTORY_VIEW: "reports/logs.call_history.view",
    CALL_RECORDINGS_VIEW: "reports/logs.call_recordings.view",
    USER_PROFILE_GENERAL_VIEW: "required_access.general.view",
    USER_PROFILE_GENERAL_EDIT: "required_access.general.edit",
    USER_PROFILE_TEAMS_VIEW: "required_access.teams.view",
    USER_PROFILE_PREFERENCES_VIEW: "required_access.preferences.view",
    USER_PROFILE_PREFERENCES_ADD: "required_access.preferences.add",
    USER_PROFILE_PREFERENCES_EDIT: "required_access.preferences.edit",
    USER_PROFILE_PREFERENCES_DELETE: "required_access.preferences.delete",
    USERS_EDIT: "settings.general_settings.users.edit",
    MASTER_ACCOUNT_VIEW: "records.master_account.view",
    MASTER_ACCOUNT_ADD: "records.master_account.add",
    MASTER_ACCOUNT_EDIT: "records.master_account.edit",
    MASTER_ACCOUNT_DELETE: "records.master_account.delete",
    ACCOUNT_VIEW: "records.account.view",
    ACCOUNT_ADD: "records.account.add",
    ACCOUNT_EDIT: "records.account.edit",
    ACCOUNT_DELETE: "records.account.delete",
    CONTACTS_VIEW: "records.contacts.view",
    CONTACTS_ADD: "records.contacts.add",
    CONTACTS_EDIT: "records.contacts.edit",
    CONTACTS_DELETE: "records.contacts.delete",
    LEAD_VIEW: "records.module_lead.view",
    LEAD_ADD: "records.module_lead.add",
    LEAD_EDIT: "records.module_lead.edit",
    OPPORTUNITY_VIEW: "records.module_opportunity.view",
    OPPORTUNITY_ADD: "records.module_opportunity.add",
    OPPORTUNITY_EDIT: "records.module_opportunity.edit",
    OWNERSHIP_ASSIGNMENT_ADD: "records.ownership_assignment.add",
    OWNERSHIP_ASSIGNMENT_EDIT: "records.ownership_assignment.edit",
    ORDERS_ADD: "records.orders.add",
    ORDERS_EDIT: "records.orders.edit",
    USERS_VIEW: "settings.general_settings.users.view",
    USERS_ADD: "settings.general_settings.users.add",
    USERS_DELETE: "settings.general_settings.users.delete",
    TEAMS_VIEW: "settings.general_settings.teams.view",
    TEAMS_ADD: "settings.general_settings.teams.add",
    TEAMS_EDIT: "settings.general_settings.teams.edit",
    TEAMS_DELETE: "settings.general_settings.teams.delete",
    SCHEDULE_VIEW: "settings.general_settings.schedule.view",
    SCHEDULE_EDIT: "settings.general_settings.schedule.edit",
    PERMISSIONS_VIEW: "settings.general_settings.permissions.view",
    PERMISSIONS_ADD: "settings.general_settings.permissions.add",
    PERMISSIONS_EDIT: "settings.general_settings.permissions.edit",
    PERMISSIONS_DELETE: "settings.general_settings.permissions.delete",
    TERRITORIES_VIEW: "settings.general_settings.territories.view",
    TERRITORIES_ADD: "settings.general_settings.territories.add",
    TERRITORIES_EDIT: "settings.general_settings.territories.edit",
    TERRITORIES_DELETE: "settings.general_settings.territories.delete",
    COMPANY_PROFILE_VIEW: "settings.account_management.company_profile.view",
    COMPANY_PROFILE_EDIT: "settings.account_management.company_profile.edit",
    BILLING_VIEW: "settings.account_management.billing.view",
    BILLING_ADD: "settings.account_management.billing.add",
    BILLING_DELETE: "settings.account_management.billing.delete",
    BILLING_EDIT: "settings.account_management.billing.edit",
    WEB_FORMS_VIEW: "settings.integrations_data_import.web_forms.view",
    WEB_FORMS_ADD: "settings.integrations_data_import.web_forms.add",
    WEB_FORMS_EDIT: "settings.integrations_data_import.web_forms.edit",
    WEB_FORMS_DELETE: "settings.integrations_data_import.web_forms.delete",
    IMPORT_DATA_VIEW: "settings.integrations_data_import.import_data.view",
    IMPORT_DATA_ADD: "settings.integrations_data_import.import_data.add",
    IMPORT_DATA_DELETE: "settings.integrations_data_import.import_data.delete",
    DATA_PROVIDERS_VIEW:
        "settings.integrations_data_import.data_providers.view",
    DATA_PROVIDERS_ADD: "settings.integrations_data_import.data_providers.add",
    DATA_PROVIDERS_EDIT:
        "settings.integrations_data_import.data_providers.edit",
    DATA_PROVIDERS_DELETE:
        "settings.integrations_data_import.data_providers.delete",
    ACTIVITIES_VIEW: "settings.crm_customization.activities.view",
    ACTIVITIES_ADD: "settings.crm_customization.activities.add",
    ACTIVITIES_EDIT: "settings.crm_customization.activities.edit",
    ACTIVITIES_DELETE: "settings.crm_customization.activities.delete",
    LIBRARY_VIEW: "settings.crm_customization.library.view",
    LIBRARY_ADD: "settings.crm_customization.library.add",
    LIBRARY_EDIT: "settings.crm_customization.library.edit",
    LIBRARY_DELETE: "settings.crm_customization.library.delete",
    PRODUCT_CATALOG_VIEW: "settings.crm_customization.product_catalog.view",
    PRODUCT_CATALOG_ADD: "settings.crm_customization.product_catalog.add",
    PRODUCT_CATALOG_PRODUCTS_ADD: "settings.crm_customization.product_catalog.products.add",
    PRODUCT_CATALOG_CATEGORY_ADD: "settings.crm_customization.product_catalog.category.add",
    PRODUCT_CATALOG_EDIT: "settings.crm_customization.product_catalog.edit",
    PRODUCT_CATALOG_DELETE: "settings.crm_customization.product_catalog.delete",
    PIPELINE_VIEW: "settings.crm_customization.pipeline.view",
    PIPELINE_ADD: "settings.crm_customization.pipeline.add",
    PIPELINE_EDIT: "settings.crm_customization.pipeline.edit",
    PIPELINE_DELETE: "settings.crm_customization.pipeline.delete",
    DATA_CUSTOMIZATION_VIEW:
        "settings.crm_customization.data_customization.view",
    DATA_CUSTOMIZATION_ADD: "settings.crm_customization.data_customization.add",
    DATA_CUSTOMIZATION_EDIT:
        "settings.crm_customization.data_customization.edit",
    DATA_CUSTOMIZATION_DELETE:
        "settings.crm_customization.data_customization.delete",
    SEQUENCES_VIEW: "settings.automation.sequences.view",
    SEQUENCES_ADD: "settings.automation.sequences.add",
    SEQUENCES_EDIT: "settings.automation.sequences.edit",
    SEQUENCES_DELETE: "settings.automation.sequences.delete",
    ASSIGNMENT_RULES_VIEW: "settings.automation.assignment_rules.view",
    ASSIGNMENT_RULES_ADD: "settings.automation.assignment_rules.add",
    ASSIGNMENT_RULES_EDIT: "settings.automation.assignment_rules.edit",
    ASSIGNMENT_RULES_DELETE: "settings.automation.assignment_rules.delete",
    DATA_INTEGRATION_LOG_REPORT_VIEW: 
        "settings.reports_and_logs.data_integration_log/_data_mapping.view",
    DATA_INTEGRATION_LOG_REPORT_ADD:
        "settings.reports_and_logs.data_integration_log/_data_mapping.add",
    DATA_INTEGRATION_LOG_REPORT_EDIT:
        "settings.reports_and_logs.data_integration_log/_data_mapping.edit",
    SEQUENCE_REPORT_VIEW: "settings.reports_and_logs.sequence_report.view",
    SEQUENCE_REPORT_EDIT: "settings.reports_and_logs.sequence_report.edit",
    SEQUENCE_REPORT_DELETE: "settings.reports_and_logs.sequence_report.delete",
    QUOTES_AND_ORDERS_REPORT_VIEW: "settings.reports_and_logs.quotes_&_orders_report.view",
    INVOICE_REPORT_VIEW: "settings.reports_and_logs.invoices_report.view",
    CAMPAIGNS_VIEW: "campaigns.view",
    CAMPAIGNS_ADD: "campaigns.add",
    CAMPAIGNS_EDIT: "campaigns.edit",
    CAMPAIGNS_DELETE: "campaigns.delete",
    GROUPS_SUBGROUPS_VIEW: "groups_subgroups.view",
    GROUPS_SUBGROUPS_ADD: "groups_subgroups.add",
    GROUPS_SUBGROUPS_EDIT: "groups_subgroups.edit",
    GROUPS_SUBGROUPS_DELETE: "groups_subgroups.delete",
    CALENDAR_VIEW: "calendar.view",
    CALENDAR_ADD: "calendar.add",
    CALENDAR_EDIT: "calendar.edit",
    CALENDAR_DELETE: "calendar.delete",
    DASHBOARDS_VIEW: "dashboards.view",
    QUOTES_ORDERS_VIEW: "reports/logs.quotes/orders.view",
    INVOICE_VIEW: "reports/logs.invoice.view",
    SEQUENCES_REPORT_VIEW: "reports/logs.sequence_report.view",
    SEQUENCES_REPORT_EDIT: "reports/logs.sequence_report.edit",
    SEQUENCES_REPORT_DELETE: "reports/logs.sequence_report.delete",
    PIPELINES_VIEW: "reports/logs.pipeline_history_report.view",
    PIPELINES_REPORT_VIEW: "settings.reports_and_logs.pipeline_history_report.view",
};

export const PRODUCT_PERMISSIONS = {
    SETTINGS_PHONE_MANAGEMENT: "settings/phone-management/",
    SETTINGS_EXTERNAL_NUMBERS: "numbers/external-numbers",
    OFFICE_VIEW: "officeView",
    SETTINGS_CALL_TAGS: "settings/library/call-tags",
    TEXT_VIEW: "textView",
    RECORDS: "records",
    SETTINGS_USAGE_STATS: "settings/usage-stats",
    SETTINGS_DIALER_SCRIPTS: "settings/library/dialer-scripts",
    SETTINGS_EMAIL_TEMPLATES: "settings/library/email-templates",
    SETTINGS_TEXT_TEMPLATES: "settings/library/text-templates",
    SETTINGS_PERMISSION_PROFILE: "settings/permission-profile",
    SETTINGS_SEQUENCES: "settings/sequences",
    SETTINGS_DATA_CUSTOMIZATION: "settings/data-customization",
    SETTINGS_USERS: "settings/users",
    SETTINGS_TEAMS: "settings/teams",
    SETTINGS_ASSIGNMENT_RULES: "settings/assignment-rules/assignment-rules", 
    SETTINGS_DATA_PROVIDERS: "settings/data-providers", 
    SETTINGS_PRODUCT_CATALOG: "settings/product-catalog-quotes-invoices/product-catalog",
};

//Edit if add or remove permissions from settings, to disable gear icon, as well as the full setting section if all access_control = off
export const SETTINGS_PERMISSION_MAP = {
    general: [
        USER_PERMISSIONS.USERS_VIEW,
        USER_PERMISSIONS.TEAMS_VIEW,
        USER_PERMISSIONS.PERMISSIONS_VIEW,
        USER_PERMISSIONS.SCHEDULE_VIEW,
        USER_PERMISSIONS.TERRITORIES_VIEW,
    ],
    "account-management": [
        USER_PERMISSIONS.COMPANY_PROFILE_VIEW,
        USER_PERMISSIONS.BILLING_VIEW,
        USER_PERMISSIONS.USAGE_STATS_VIEW
    ],
    "phone-management": [USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW],
    integrations: [
        USER_PERMISSIONS.WEB_FORMS_VIEW,
        USER_PERMISSIONS.IMPORT_DATA_VIEW,
        USER_PERMISSIONS.DATA_PROVIDERS_VIEW,
    ],
    "crm-customizations": [
        USER_PERMISSIONS.ACTIVITIES_VIEW,
        USER_PERMISSIONS.LIBRARY_VIEW,
        USER_PERMISSIONS.PRODUCT_CATALOG_VIEW,
        USER_PERMISSIONS.PIPELINE_VIEW,
        USER_PERMISSIONS.DATA_CUSTOMIZATION_VIEW
    ],
    automation: [
        USER_PERMISSIONS.SEQUENCES_VIEW,
        USER_PERMISSIONS.ASSIGNMENT_RULES_VIEW,
    ],
    "reports-and-logs": [
        USER_PERMISSIONS.DATA_INTEGRATION_LOG_REPORT_VIEW,
        USER_PERMISSIONS.QUOTES_AND_ORDERS_REPORT_VIEW,
        USER_PERMISSIONS.INVOICE_REPORT_VIEW,
        USER_PERMISSIONS.CALL_HISTORY_REPORT_VIEW,
        USER_PERMISSIONS.SEQUENCE_REPORT_VIEW,
        USER_PERMISSIONS.TEXTING_HISTORY_REPORT_VIEW,
        USER_PERMISSIONS.PIPELINES_REPORT_VIEW,
        USER_PERMISSIONS.ARCHIVE_VIEW,
    ],
};